var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wl-container" },
    [
      _vm.updateGuide ? _c("div", { staticClass: "updateGuide" }) : _vm._e(),
      _c(
        "div",
        { staticClass: "wl-content-container" },
        [
          _c("div", { staticClass: "wl-info" }, [
            _c("div", { staticClass: "block enpar" }, [
              _c("img", {
                staticClass: "left block-icon",
                attrs: { src: _vm.PartnerIcon },
              }),
              _c("div", { staticClass: "right" }, [
                _c("div", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.ownerName ? _vm.ownerName : " ")),
                ]),
                _c("div", { staticClass: "position" }, [
                  _vm._v(_vm._s(_vm.$t("PAGE_KPMG_TEAM_OWNER"))),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "divider" }),
            _c("div", { staticClass: "block engmanager" }, [
              _c("img", {
                staticClass: "left block-icon",
                attrs: { src: _vm.ManagerIcon },
              }),
              _c("div", { staticClass: "right" }, [
                _c("div", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.managerName ? _vm.managerName : " ")),
                ]),
                _c("div", { staticClass: "position" }, [
                  _vm._v(_vm._s(_vm.$t("PAGE_KPMG_TEAM_MANGER"))),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "divider" }),
            _c("div", { staticClass: "block siteadmin" }, [
              _c("img", {
                staticClass: "left block-icon",
                attrs: { src: _vm.SiteAdminIcon },
              }),
              _c(
                "div",
                { staticClass: "right", staticStyle: { width: "100%" } },
                [
                  _c(
                    "div",
                    { staticClass: "name" },
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: _vm.adminNameList(_vm.adminName),
                            placement: "top-end",
                            disabled: !_vm.showAdminTooltip,
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              ref: "adminNameList",
                              staticClass: "name-text",
                              on: { mouseover: _vm.calcShowAdminTooltip },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.adminNameList(_vm.adminName)
                                    ? _vm.adminNameList(_vm.adminName)
                                    : " "
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "editicon",
                          on: {
                            click: function ($event) {
                              return _vm.editName("admin")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-edit" }),
                          _c("span", [_vm._v(_vm._s(_vm.$t("COMMON_EDIT")))]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "position" }, [
                    _vm._v(_vm._s(_vm.$t("PAGE_KPMG_TEAM_ADMIN"))),
                  ]),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "wl-search-bar" }, [
            _c(
              "div",
              { staticClass: "wl-left" },
              [
                _c(
                  "el-input",
                  {
                    staticClass: "input-with-select",
                    attrs: {
                      placeholder:
                        _vm.$t("TABLE_HEADER_EMAIL_StaffNo") +
                        "," +
                        _vm.$t("TABLE_HEADER_EMAIL_StaffName") +
                        "," +
                        _vm.$t("TABLE_HEADER_EMAIL_ProfitCenter"),
                      clearable: "",
                      maxlength: "100",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.searchUser.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.searchContent,
                      callback: function ($$v) {
                        _vm.searchContent = $$v
                      },
                      expression: "searchContent",
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "el-input__icon el-icon-search",
                      staticStyle: { cursor: "pointer" },
                      attrs: { slot: "suffix" },
                      on: { click: _vm.searchUser },
                      slot: "suffix",
                    }),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "wl-right" },
              [
                _c("select-ad", {
                  ref: "selectAdd",
                  staticClass: "select-ad-cls",
                  attrs: {
                    api: _vm.selectFromAD,
                    filter: _vm.adFilter,
                    onAdd: _vm.onAddAccount,
                  },
                }),
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green svg-btn",
                    attrs: { disabled: _vm.patchSerRole.showCheck },
                    on: {
                      click: function ($event) {
                        return _vm.onPatchRoleClick("role")
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "btn-icon",
                      attrs: {
                        src: require("@/assets/img/icon-batchsetting.svg"),
                        width: "100%",
                      },
                    }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("patch_set_role")) +
                        "\n                "
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green svg-btn",
                    attrs: { disabled: _vm.patchSerRole.showCheck },
                    on: {
                      click: function ($event) {
                        return _vm.onPatchRoleClick("delete")
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "btn-icon",
                      attrs: {
                        src: require("@/assets/img/icon-batchdeletion.svg"),
                        width: "100%",
                      },
                    }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("patch_delete_user")) +
                        "\n                "
                    ),
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "wl-green",
                    staticStyle: { "margin-right": "10px" },
                    attrs: { icon: "el-icon-download" },
                    on: { click: _vm.download },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("COMMON_DOWNLOAD_TEMP")) +
                        "\n                "
                    ),
                  ]
                ),
                _c(
                  "el-upload",
                  {
                    staticClass: "template-uploader",
                    attrs: {
                      action: "url",
                      "http-request": _vm.uploadFiles,
                      "show-file-list": false,
                      "on-success": _vm.handleAvatarSuccess,
                      "before-upload": _vm.beforeAvatarUpload,
                    },
                  },
                  [
                    _c("el-button", { staticClass: "wl-green svg-btn" }, [
                      _c("img", {
                        staticClass: "btn-icon",
                        attrs: {
                          src: require("@/assets/img/icon-import.svg"),
                          width: "100%",
                        },
                      }),
                      _vm._v(
                        _vm._s(_vm.$t("COMMON_IMPORT")) +
                          "\n                    "
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              class: [
                "table-container-wrapper",
                _vm.patchSerRole.showCheck ? "show-table-bottom-operate" : "",
                { "guide-table": _vm.updateGuide },
              ],
            },
            [
              _vm.updateGuide
                ? _c(
                    "div",
                    {
                      staticClass: "updateGuideTitle",
                      style: {
                        height: `${_vm.updateGuideTitleHeight}px`,
                        right: "100px",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "updateGuideTip",
                          style: {
                            top: `${_vm.updateGuideTitleHeight + 10}px`,
                          },
                        },
                        [
                          _c("div", {
                            staticClass: "margin-bottom-10",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("KP_NOTICE")),
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              staticClass: "guide-btn",
                              on: { click: _vm.gotItClick },
                            },
                            [_vm._v(_vm._s(_vm.$t("gotIt")))]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: {
                    data: _vm.data,
                    height: "100%",
                    border: "",
                    stripe: "",
                    "cell-class-name": _vm.noRoleCell,
                    "header-cell-class-name": _vm.updateGuideClass,
                  },
                  on: { "selection-change": _vm.onTableCheckChange },
                },
                [
                  this.patchSerRole.showCheck
                    ? _c("el-table-column", {
                        attrs: { type: "selection", width: "55" },
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: { type: "index", align: "center", width: "70" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "staffNo",
                      label: _vm.$t("TABLE_HEADER_EMAIL_StaffNo"),
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userName",
                      "min-width": 180,
                      label: _vm.$t("TABLE_HEADER_EMAIL_StaffName"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "profitCenter",
                      "min-width": 180,
                      label: _vm.$t("TABLE_HEADER_EMAIL_ProfitCenter"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ifContact",
                      width: "180",
                      align: "center",
                      label: _vm.$t("TABLE_HEADER_KPifContact"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-switch", {
                              attrs: {
                                "active-color": "#3879eb",
                                "inactive-color": "#a9acaf",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeIfContact(scope.row)
                                },
                              },
                              model: {
                                value: scope.row.ifContact,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "ifContact", $$v)
                                },
                                expression: "scope.row.ifContact",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "email",
                      "min-width": 150,
                      label: _vm.$t("TABLE_HEADER_EMAIL_Email"),
                    },
                  }),
                  _c(
                    "el-table-column",
                    {
                      attrs: { width: "180", fixed: "right" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("KPAccessLevelSelect", {
                                attrs: { initData: scope.row.accessType },
                                on: {
                                  change: (val) =>
                                    _vm.handleAccessLevelChange(scope.row, val),
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#fd349c",
                                "margin-right": "5px",
                                "vertical-align": "center",
                              },
                            },
                            [_vm._v("*")]
                          ),
                          _vm._v(
                            _vm._s(_vm.$t("TABLE_HEADER_Access_Level")) +
                              "\n                        "
                          ),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" },
                            },
                            [
                              _c("div", {
                                attrs: { slot: "content" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("TABLE_HEADER_KP_Access_Level_Tip")
                                  ),
                                },
                                slot: "content",
                              }),
                              _c("i", {
                                staticClass: "el-icon-warning",
                                staticStyle: {
                                  color: "#fd349c",
                                  "margin-right": "5px",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        width: "200",
                        fixed: "right",
                        label: _vm.$t("TABLE_HEADER_CLIENT_ENTITIES"),
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !scope.row.accessType
                                ? _c("el-select", {
                                    key: scope.$index + "null",
                                    staticStyle: { width: "100%" },
                                    attrs: { value: "" },
                                  })
                                : scope.row.accessType === "ALL"
                                ? _c("el-select", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: "",
                                      value: _vm.$t("All_ENTITIES"),
                                    },
                                  })
                                : scope.row.accessType !== "ALL" &&
                                  scope.row.refresh
                                ? _c("select-tree", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "mini",
                                      data: _vm.orgData,
                                      filterable: true,
                                      "check-strictly": true,
                                      defaultCheckedKeys:
                                        scope.row.clientEntityIds,
                                      defaultExpandAll: true,
                                      defaultProps: _vm.defaultProps,
                                    },
                                    on: {
                                      "visible-change": (list) =>
                                        _vm.handleVisibleChange(
                                          scope.row,
                                          list
                                        ),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#fd349c",
                              "margin-right": "5px",
                              "vertical-align": "center",
                            },
                          },
                          [_vm._v("*")]
                        ),
                        _vm._v(
                          _vm._s(_vm.$t("TABLE_HEADER_CLIENT_ENTITIES")) +
                            "\n                    "
                        ),
                      ]),
                    ],
                    2
                  ),
                  _c("el-table-column", {
                    attrs: {
                      prop: "action",
                      width: "100",
                      fixed: "right",
                      align: "center",
                      label: _vm.$t("COMMON_DELETE"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("i", {
                              staticClass: "el-icon-delete wl-icon-delete",
                              on: {
                                click: function ($event) {
                                  return _vm.onDeleteAccount(scope.row)
                                },
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.patchSerRole.showCheck
            ? _c(
                "div",
                { staticClass: "wl-btn-container" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "cancel-btn",
                      attrs: { loading: _vm.patchSerRole.loading },
                      on: { click: _vm.cancelPatchRole },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("btn_cancel")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm.patchSerRole.showCheck &&
                  _vm.patchSerRole.mode == "delete"
                    ? _c(
                        "el-button",
                        {
                          staticClass: "wl-green",
                          attrs: {
                            disabled: _vm.patchSerRole.users.length <= 0,
                            loading: _vm.patchSerRole.loading,
                          },
                          on: { click: _vm.beginPatchDelete },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("patch_delete_user")) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.patchSerRole.showCheck && _vm.patchSerRole.mode == "role"
                    ? _c(
                        "el-button",
                        {
                          staticClass: "wl-green",
                          attrs: {
                            disabled: _vm.patchSerRole.users.length <= 0,
                            loading: _vm.patchSerRole.loading,
                          },
                          on: { click: _vm.beginPatchRole },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("patch_set_role")) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c("el-pagination", {
            staticClass: "wl-pagination",
            attrs: {
              "current-page": _vm.pagination.pageNum,
              "page-size": _vm.pagination.pageSize,
              "page-sizes": [10, 50, 100],
              layout: "prev, pager, next, sizes, total",
              total: _vm.pagination.total,
            },
            on: {
              "current-change": _vm.onCurrentPageChange,
              "size-change": _vm.onSizeChange,
            },
          }),
        ],
        1
      ),
      _vm.addVisible
        ? _c("AdUserInfo", {
            attrs: {
              nameFlag: _vm.nameFlag,
              isArray: _vm.isArray,
              saveLoading: _vm.btnLoading,
              initData: _vm.initData,
              onCancel: _vm.toggleAddVisible,
              onAdd: _vm.saveAdUser,
            },
          })
        : _vm._e(),
      _c("kpPatchRoleDialog", {
        attrs: {
          visible: _vm.patchRoleVisible,
          data: _vm.orgData,
          allNodes: _vm.allNodes,
        },
        on: {
          submit: _vm.batchSetRole,
          close: function ($event) {
            _vm.patchRoleVisible = false
          },
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("COMMON_ADD"),
            visible: _vm.dialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          !_vm.alertVisible
            ? _c(
                "span",
                { staticStyle: { margin: "10px", "word-break": "normal" } },
                [
                  _vm._v(" " + _vm._s(_vm.$t("msg_submit_sure")) + " "),
                  _c("br"),
                  _c("br"),
                ]
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "cancel-btn",
                  on: {
                    click: function ($event) {
                      return _vm.closeDialog()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("btn_cancel")))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "wl-green",
                  attrs: {
                    type: "primary",
                    disabled: _vm.alertVisible,
                    loading: _vm.addingStaff,
                  },
                  on: { click: _vm.addAccount },
                },
                [_vm._v(_vm._s(_vm.$t("btn_confirm")))]
              ),
            ],
            1
          ),
          _vm.alertVisible
            ? _c(
                "div",
                {
                  staticStyle: {
                    "background-color": "#fef0f0",
                    color: "#f56c6c",
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.$t(_vm.alertI18N)) },
                  }),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }